import ResolveDuplicateSiteMap from './ResolveDuplicateSiteMap'

export default ResolveDuplicateSiteMap
